import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { mockArticles } from '@/mocks/articles';

export default function DeepFeature() {
  const { t } = useTranslation();
  const features = mockArticles.filter((a) => !a.featured && a.category !== 'influencer-gossip').slice(0, 3);

  if (features.length < 3) return null;

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-4xl text-foreground-950">
              {t('category_deepFeature_title1')}
              <br />
              {t('category_deepFeature_title2')}
            </h2>
          </div>
          <p className="text-sm text-foreground-600">{t('category_deepFeature_subtitle')}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group block rounded-2xl bg-background-100 overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer ${
                idx === 0 ? 'md:col-span-1' : ''
              }`}
            >
              {idx === 0 ? (
                <>
                  <div className="relative w-full aspect-[16/10] overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
                      {article.categoryName}
                    </span>
                    <h3 className="text-base md:text-lg font-semibold text-foreground-950 line-clamp-2 mb-2">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-600">{article.excerpt}</p>
                  </div>
                </>
              ) : (
                <>
                  <div className="p-5">
                    <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
                      {article.categoryName}
                    </span>
                    <h3 className="text-base font-semibold text-foreground-950 line-clamp-3 mb-3 text-center">
                      {article.title}
                    </h3>
                  </div>
                  <div className="relative w-full aspect-[16/9] overflow-hidden">
                    <img
                      src={article.imageUrl}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </>
              )}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}